import type { EnterpriseSettingsResponse } from '../api';

export const DEFAULT_BRAND_NAME = 'RocketFee';

/**
 * Header rows for Excel exports. Same order as the PDF header:
 * Organization Settings, then the tenant name, then RocketFee.
 */
export function buildExportBrandingRows(
	settings: EnterpriseSettingsResponse | undefined,
	tenantName: string | undefined,
): string[][] {
	if (!settings) {
		return [[tenantName || DEFAULT_BRAND_NAME], ['']];
	}
	const { address = {}, contact = {} } = settings;
	const cityLine = [address.city, address.state, address.zip]
		.filter(Boolean)
		.join(', ');
	const lines = [
		settings.company_name,
		address.street,
		cityLine,
		contact.phone && `Phone: ${contact.phone}`,
		contact.email && `Email: ${contact.email}`,
		contact.website,
	].filter((line): line is string => Boolean(line));
	return [...lines.map((line) => [line]), ['']];
}
